import Vue from 'vue'
import Router from 'vue-router'
const index = resolve => require(['@/components/homePage/index'], resolve)
const login=resolve=>require(['@/components/login/login'],resolve)
const homeindex=resolve =>require(['@/components/home/homeindex'],resolve)

const infouito=resolve =>require(['@/components/home/subassembly/infouito'],resolve)
const search =resolve=>require(['@/components/home/search'],resolve)
const phoneindex=resolve => require(['@/components/homePage/phoneindex'], resolve)

//const videoResources=resolve=>require(['@/components/homePage/subassembly/videoResources'],resolve)//视频资源组件
//const imagesup =resolve=>require(['@/components/home/subassembly/imagesup'],resolve)//上传图片组件


// const person_center = resolve => require(['@/components/person/person_center'], resolve) //个人中心
// const about_us = resolve => require(['@/components/news/about_us.vue'], resolve) 
const p_404 = resolve => require(['@/components/base/404.vue'], resolve) //404页面
Vue.use(Router)
export default new Router({
  routes: [
//     {
//       path: '/',
//       name: 'login',
//       component: login
// }, 

{
  path:'/',
  name:'index',
  component:index
},
{
  path:'/phoneindex',
  name:'phoneindex',
  component:phoneindex

},
// {
//   path:'homePage/videoResources',
//   name:'videoResources',
//   component:videoResources
// },

    {
      path:'/homeindex',
      name:'homeindex',
      component:homeindex,
    },
 

    // {
    //   path:'/home/subassembly',
    //   name:'imagesup',
    //   component:imagesup
    // },





    //  // 他的个人中心
    // {
    //   path: "/person_center/heCenter",
    //   component: () => import("@/components/person/heCenter"),
    //   beforeEnter: function(to, from, next) {
    //     if (!localStorage.token && !localStorage.usinfo) {
    //       Vue.prototype.$message.error("请先登录!");
    //       Vue.prototype.store.commit("setisLogin", 1);
    //       console.log(from);
    //       return next(from.fullPath); //或者返回你需要的地址
    //     }
    //     next();
    //   }
    // },
    //个人中心
    // {
    //   path: "/person_center",
    //   component: person_center,
    //   redirect: "/person_center/recommend",
    //   beforeEnter: function(to, from, next) {
    //     if (parseInt(to.query.user_id) == parseInt(localStorage.uid))
    //       return next("/person_center");
    //     if (!localStorage.token && !localStorage.usinfo) {
    //       Vue.prototype.$message.error("请先登录!");
    //       Vue.prototype.store.commit("setisLogin", 1);
    //       return next("/"); //或者返回你需要的地址
    //     }
    //     next();
    //   },
    //   children: [
    //     {
    //       path: "/person_center/recommend",
    //       component: () => import("../components/person/recommend")
    //     },

    //     {
    //       path: "/person_center/notice",
    //       component: () => import("../components/person/notice")
    //     },
    //     {
    //       path: "/person_center/promote",
    //       component: () => import("../components/person/promote")
    //     },
    //     {
    //       path: "/person_center/safety",
    //       component: () => import("../components/person/safety")
    //     },
    //     {
    //       path: "/person_center/myAttention",
    //       component: () => import("../components/person/myAttention")
    //     }
    //   ]
    // },
 



   
    // 新闻中心-关于我们
    // {
    //   path: "/about_us",
    //   component: about_us
    // },



     // 注册
    {
      path: "/register",
      name: "register",
      beforeEnter: function(to, from, next) {
        if (localStorage.token) {
          next("/"); //或者返回你需要的地址
          return this.$message.error("您已登录");
        }
        next();
      },
      // component: register,
      component: () => import("../components/login/register")
    },
    // 忘记密码
    {
      path: "/register/:id",
      props: true,
      // component: register,
      component: () => import("../components/login/register")
    },


    {
      path: '/404',
      name: 'p_404',
      component: p_404
    },

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js